// https://dexie.org/docs/Tutorial/Design#database-versioning
export const DATABASE_VERSION = 1;

export const DATABASE_NAME = "crossword-db";
